import React from "react"

import GiftIcon from "@public/img/gift_icon.png"
interface Props {
  current: number
  maxValue: number
}
export const NguyenbaoGamota: React.FC<Props> = ({ current, maxValue }) => {
  const percent = (current / maxValue) * 100
  return (
    <div className="w-full bg-[#FFFCF2] py-[16px] px-[14px] flex flex-col mt-[16px] rounded-[10px] border border-dashed border-[#F4CE78]">
      <div className="flex items-center justify-between w-full">
        <div className="flex flex-1">
          <img
            src={GiftIcon?.src}
            width={22}
            height={22}
            className="mr-[5px] max-w-[22px] max-h-[22px]"
          />
          <p className="text-[#FF8900] Nunito-400 text-xs">
            {`Nạp Nguyên Bảo tặng 100% NB khóa ( tối đa ${maxValue})`}
            <span className="ml-[10px] text-xs">
              (<span className="font-[600]">{current?.toLocaleString()}</span>
              {`/${maxValue?.toLocaleString()}`})
            </span>
          </p>
        </div>
      </div>
      <div className="w-full bg-[#FFF0C6] rounded-[20px] h-[14px] mt-[7px]">
        <div
          className={`bg-[#FF8900] h-[14px] rounded-tl-[20px] rounded-bl-[20px] ${
            percent >= 100 ? "rounded-br-[20px] rounded-tr-[20px]" : ""
          }`}
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  )
}
